var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.guideLineClass,attrs:{"data-cy":"受講進捗ガイドライン"}},[_c('v-icon',{attrs:{"icon":"comment"}}),_vm._v(_vm._s(this.guideLine))],1)}
var staticRenderFns = []

export { render, staticRenderFns }